var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCarrot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.114 13.887C38.33 9.248 37.188 3.75 32.657 0c-4.346 3.604-5.537 8.79-3.653 13.291-1.367-.479-2.763-.791-4.15-.791a12.67 12.67 0 00-11.387 7.11L.235 46.708a2.286 2.286 0 000 2.002c.4.81 1.21 1.28 2.05 1.28.333 0 .674-.079 1.006-.235l27.11-13.233a12.636 12.636 0 005.82-5.82 12.586 12.586 0 00.596-9.658c4.482 1.826 9.61.615 13.193-3.701-3.77-4.532-9.258-5.674-13.896-3.457zm-4.112 14.765a7.88 7.88 0 01-3.662 3.663l-5.596 2.734-2.334-2.334a2.334 2.334 0 00-3.31 0c-.908.918-.918 2.402 0 3.31l1.191 1.192-10.78 5.273 9.384-19.219 3.32 3.39a2.328 2.328 0 001.66.683c.606 0 1.201-.225 1.66-.684a2.334 2.334 0 000-3.31l-4.062-3.995c1.445-1.337 3.32-2.158 5.38-2.158 1.212 0 2.384.274 3.487.81a7.938 7.938 0 014.043 4.571 7.907 7.907 0 01-.38 6.074z",
    fill: "#91C300"
  })));
}

export default SvgCarrot;